import React from 'react';
import PropTypes from 'prop-types';
import { CallupHead } from '@ifeng-fe/three_terminal/es/mobile/callupHead/dynamic';
import errorBoundary from '@ifeng-fe/errorBoundary';

const TopColumn = ({ content }) => {
    const nineDomain = typeof window === 'object' && window.allData?.__nd__ ? window.allData.__nd__ : 'ne883dbn.ifeng.com';
    const headData = {
        isVideoShare: false,
        pageInfo: {
            // 页面曝光
            type: 'news3hoursList',
            url: location.href,
            id: `https://${ nineDomain }/news3hoursList`,
            noKindFrom: 1,
            kind: 'inter_3hfx01',
            downloads: {
                download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7199259069945391104',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9085',
            },
        },
        topClickInfo: {
            // 顶部曝光
            behavior: 'action',
            type: '3hourtop',
            kind: 'article',
            callupKind: 'inter_3hfx01',
        },
        fixClickInfo: {
            // 浮动曝光
            behavior: 'action',
            type: '3hourtop',
            kind: 'article',
            callupKind: 'inter_3hfx01',
        },
        hotKeyword: content.headKeyword,
        wxLaunchType: 'app',
        wxLaunchSwitch: 1,
    };

    return <>{<CallupHead content={headData} />}</>;
};

TopColumn.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(TopColumn);
